let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("khomJ")).then(() => parcelRequire('9XVn7'));